import { render, staticRenderFns } from "./OffersAndPromotionsSlider.vue?vue&type=template&id=73ff2ecb&"
import script from "./OffersAndPromotionsSlider.vue?vue&type=script&lang=js&"
export * from "./OffersAndPromotionsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports